import "../../stylesheets/about-package/about.less";
import "../../stylesheets/grids-package/grids.less";
import "../../stylesheets/mobile-package/mobile.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import * as React from "react";
import {useParams} from "react-router";

import {staticUrl} from "@khan/urls";

import PageRoot from "#app-shell-package/page-root.tsx";
import {LegalDocumentViewer} from "#legal-package/legal-document-viewer.tsx";

import AboutHeader from "./about-header.tsx";
import {withStrings} from "./locales/about-docs/load-strings.tsx";

function AboutDocs(): React.ReactNode {
    const urlParams = useParams<{
        slug: string;
    }>();

    return (
        <PageRoot settings={{title: t`About Docs`}}>
            <div className="about-page">
                <Header />
                <LegalDocumentViewer slug={urlParams.slug} />
            </div>
        </PageRoot>
    );
}

function Header(): React.ReactNode {
    return (
        <AboutHeader
            className="header-with-background-video"
            backgroundVideo={
                // Snippets of a series of khan academy video lessons.
                <video className="responsive-video" loop muted={true} autoPlay>
                    <source
                        src={staticUrl("/videos/homepage-background.mp4")}
                        type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
                    />
                    <source
                        src={staticUrl("/videos/homepage-background.webm")}
                        type='video/webm; codecs="vp8, vorbis"'
                    />
                    <source
                        src={staticUrl("/videos/homepage-background.ogv")}
                        type='video/ogv; codecs="theora, vorbis"'
                    />
                </video>
            }
        />
    );
}

export default withStrings(AboutDocs);
